import { mapGetters, mapActions } from 'vuex';
import { GcHeading, GcLoader } from '@garmin/components-global';
import RelatedCard from '@/components/RelatedCard/index.vue';
import ProductCard from '@/components/ProductCard/index.vue';
import AdditionalContainer from '@/components/AdditionalContainer/index.vue';

export default {
  name: 'Sidebar',
  components: {
    RelatedCard,
    ProductCard,
    GcLoader,
    GcHeading,
    AdditionalContainer,
  },
  data() {
    return {
      relatedLinksLoaded: false,
      compatibleProductsLoaded: false,
      crossSellProductsLoaded: false,
      upSellProductsLoaded: false,
    };
  },
  computed: {
    containerClass() {
      return this.isBottomPosition ? 'app__sidebar__full' : 'app__sidebar';
    },
    relatedCardClass() {
      return {
        app__sidebar__card: true,
      };
    },
    showRelatedLinks() {
      return this.relatedLinksLoaded
        && (this.showManuals || this.showFAQ || this.showSoftwareLink || this.showQuickLinks);
    },
    showCompatible() {
      return this.compatibleProducts.length !== 0 && this.compatibleProductsLoaded;
    },
    showCrossSell() {
      return this.crossSellProducts.length !== 0 && this.crossSellProductsLoaded;
    },
    showUpSell() {
      return this.upSellProducts.length !== 0 && this.upSellProductsLoaded;
    },
    showManuals() {
      if (this.manualsLink) {
        return this.manualsLink.showManuals;
      }
      return false;
    },
    showFAQ() {
      if (this.quickLinks) {
        return this.quickLinks.showFAQ;
      }
      return false;
    },
    showQuickLinks() {
      if (this.quickLinks) {
        return this.quickLinks.content;
      }
      return false;
    },
    isBottomPosition() {
      return this.newOverviewTab && this.activeTabId === 'overview';
    },
    ...mapGetters({
      quickLinks: 'getSidebarQuickLinks',
      additionalContainerContent: 'getSidebarAdditionalContent',
      showAdditionalContainerContent: 'getShowSidebarAdditionalContent',
      translations: 'getTranslations',
      softwareLink: 'getSoftwareLink',
      showSoftwareLink: 'getShowSoftwareLink',
      productId: 'getProductId',
      partNumber: 'getPartNumber',
      locale: 'getLocale',
      buyGarminEndpoint: 'getBuyGarminEndpoint',
      storeCode: 'getStoreCode',
      newOverviewTab: 'getNewOverviewTab',
      activeTabId: 'getProductActiveTabId',
      compatibleProducts: 'getActiveCompatibleProducts',
      faqLink: 'getActiveFaqLink',
      crossSellProducts: 'getActiveCrossSellProducts',
      upSellProducts: 'getActiveUpSellProducts',
      manualsLink: 'getActiveManualsLink',
    }),
  },
  watch: {
    partNumber() {
      // Update the sidebar data for the new part number
      this.fetchSidebarData();
    },
  },
  created() {
    this.fetchSidebarData();
  },
  methods: {
    setSidebarGaAttr(link, section) {
      return `EMS - ${section}, click, ${link}`;
    },
    ...mapActions({
      callCompatibleProducts: 'callCompatibleProducts',
      callFaqLink: 'callFaqLink',
      callCrossSellProducts: 'callCrossSellProducts',
      callUpSellProducts: 'callUpSellProducts',
      callManualsLink: 'callManualsLink',
    }),
    getProductLink(product) {
      return `${this.buyGarminEndpoint}/${this.locale}/${this.storeCode}/p/${product.guid}`;
    },
    async fetchSidebarData() {
      this.relatedLinksLoaded = false;
      this.compatibleProductsLoaded = false;
      this.crossSellProductsLoaded = false;
      this.upSellProductsLoaded = false;

      if (!this.partNumber.length) return;

      await Promise.all([
        this.setRelatedLink().finally(() => { this.relatedLinksLoaded = true; }),
        this.setCompatibleProduct().finally(() => { this.compatibleProductsLoaded = true; }),
        this.setCrossSellProducts().finally(() => { this.crossSellProductsLoaded = true; }),
        this.setUpSellProducts().finally(() => { this.upSellProductsLoaded = true; }),
      ]);
    },
    async setRelatedLink() {
      await this.callManualsLink();
      await this.callFaqLink();
    },
    async setCompatibleProduct() {
      await this.callCompatibleProducts();
    },
    async setCrossSellProducts() {
      await this.callCrossSellProducts();
    },
    async setUpSellProducts() {
      await this.callUpSellProducts();
    },
  },
};
